module.exports = __webpack_public_path__ + "static/media/registrationpage_logo.879e0526.png";